import type { Home } from '@lmc/ts-common'
import { Button, Heading } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { getNominative } from 'common/utils'
import { useRouter } from 'hooks/useRouter'
import { NAMESPACE } from 'locale'
import { selfServeConstants } from 'locale/selfServe'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

type Props = {
  exampleResidentId?: string
}

export const CarePlansStepCard: FC<Props> = ({ exampleResidentId }) => {
  const { t } = useTranslation(NAMESPACE.SELF_SERVE)

  const preferredCarePlansNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredCarePlansNominative
  )

  const preferredCarePlanName = getNominative(
    preferredCarePlansNominative,
    'Care Plan'
  )

  const preferredCarePlanNameButton = getNominative(
    preferredCarePlansNominative,
    'Care Plans'
  )

  const router = useRouter()

  return (
    <CardWrapper>
      <StyledHeading level={3}>
        {t(selfServeConstants.CARE_PLAN_STEP_TITLE, {
          variable: preferredCarePlanName
        })}
      </StyledHeading>
      <StyledHeadingDesc level={5}>
        {t(selfServeConstants.CARE_PLAN_STEP_DESC)}
      </StyledHeadingDesc>
      <FooterWrapper>
        <StyledText level={1}>
          {t(selfServeConstants.STEP_X_OF_X, {
            from: '1',
            to: '4'
          })}
        </StyledText>
        <StyledButton
          variant="popout"
          onClick={() =>
            router.navigate(`/residents/${exampleResidentId}/care-plans`)
          }
        >
          {t(selfServeConstants.GO_TO, {
            variable: preferredCarePlanNameButton
          })}
        </StyledButton>
      </FooterWrapper>
    </CardWrapper>
  )
}

const CardWrapper = styled.div`
  background-color: #fff8fa;
  padding: 18px;
  border-radius: 20px;
  margin-top: 18px;
  min-height: 280px;
  display: flex;
  flex-direction: column;
`

const FooterWrapper = styled.div`
  display: flex;
  margin-top: auto;
  align-items: center;
`

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.status.popout};
  font-weight: 400;
  margin-bottom: 10px;
`

const StyledHeadingDesc = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.status.popout};
  margin-left: auto;
  margin-right: 0px;
`

const StyledButton = styled(Button)`
  margin-bottom: 0px;
  width: fit-content;
  margin-left: 15px;
`
